module.exports = "/legacy/b56a7790e38fe3956a91e1cf7558f9b3.svg";